import { Injectable, Type } from '@angular/core';
import { MatDialog } from "@angular/material";
import { JobErrorModel } from '../models/JobErrorModel';

@Injectable()
export class ErrorTypeManagerService {
  _registeredDialogs = new Map<string, Type<any>>();

  constructor(private dialog: MatDialog) { }

  public handleType(error: JobErrorModel): void {
    if (this.canHandleType(error)) {
      this.dialog.open(this._registeredDialogs.get(error.type), {
        panelClass: 'customized-dialog',
        width: '648px',
        data: error
      });
    }
  }

  public canHandleType(error: JobErrorModel): boolean {
    return this._registeredDialogs.has(error.type) && error.errorContext!=="";
  }

  public registerDialog(errorType: string, dialogType: Type<any>): void {
    this._registeredDialogs.set(errorType, dialogType);
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/services/ErrorTypeManagerService.ts